import React from 'react';
import { styled } from 'styled-components';
import { logoYapp } from '../../../index';

const FormImage = styled.img`
  height: 208px;

  @media (max-width: 1024px) {
    height: 104px;
  }
`;

export const NLILogo: React.FC = () => {
  return <FormImage src={logoYapp} alt="Y'distri" />;
};
